var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projects"}},[_c('section',{staticClass:"section page-section container is-fluid"},[(_vm.settings.loading)?_c('spinner'):_c('div',{staticClass:"blocks"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }